import UiBtnGroup from "@/react/story/components/ui/UiBtnGroup";
import UiColorPicker from "@/react/story/components/ui/UiColorPicker";
import { ARROWS } from "@/react/story/data";
import type { Arrows, Config } from "@/react/story/types";

type Props = {
    arrows: Arrows;
    onChange: (arrows: Arrows) => void;
}

export default function UiArrows(props: Props) {
    const setConfig = (config: Partial<Config>) => props.onChange({
        ...props.arrows,
        config: { ...props.arrows.config, ...config },
    });

    return (
        <div className="d-flex flex-column gap-3">
            <div>
                <strong className="d-block">Position</strong>
                <UiBtnGroup
                    items={ARROWS}
                    isActive={v => v === props.arrows.config.alignItems}
                    set={alignItems => setConfig({ alignItems })}
                />
            </div>
            <div>
                <strong className="d-block">Couleur de la flêche</strong>
                <UiColorPicker
                    color={props.arrows.config.color}
                    onChange={color => setConfig({ color })}
                />
            </div>
            <div>
                <strong className="d-block">Couleur de l'arrière plan de la flêche</strong>
                <UiColorPicker
                    color={props.arrows.config.backgroundColor}
                    onChange={backgroundColor => setConfig({ backgroundColor })}
                />
            </div>
        </div>
    );
}
